import styled from 'styled-components';

export const ContentLogin = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const BoxLogin = styled.div`
  width: 500px;
  height: auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
  margin: 30px;
`;

export const BoxInput = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled.div`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  color: #17428d;
  margin-bottom: 16px;
`;
